import {
  InvalidateQueryFilters,
  QueryClient,
  QueryStatus,
  useQueryClient,
} from "@tanstack/react-query";
import { useState } from "react";

interface Options extends InvalidateQueryFilters {
  skipInvalidation?: boolean;
}

interface Params<T, D, C = unknown> {
  mutationFn: (p: T) => Promise<D>;
  onSuccess?: (c: QueryClient, data: D, variables: T) => void;
  options: Options;
}

export function useMutation<T, D = unknown>({
  mutationFn,
  onSuccess,
  options: { skipInvalidation, ...invalidateOptions },
}: Params<T, D>) {
  const queryClient = useQueryClient();
  const [lastParams, setLastParams] = useState<T>();

  const [{ status, data, error }, setMutationStatus] = useState<{
    data?: D;
    status?: QueryStatus;
    error?: Error;
  }>({});

  const mutate = async (params: T) => {
    setLastParams(params);
    setMutationStatus({ status: "pending" });
    mutationFn(params)
      .then((data) => {
        setMutationStatus({ status: "success", data });

        if (!skipInvalidation) queryClient.invalidateQueries(invalidateOptions);
        onSuccess?.(queryClient, data, params);
      })
      .catch((err) => {
        setMutationStatus({ status: "error", error: err });
      });
  };
  // useEffect(() => {
  //   const showError = async () => {
  //     const responseBody = await (error as any).response.json();

  //     ToastService.error(responseBody.msg);
  //   };
  //   if (error) {
  //     showError();
  //   }
  // }, [error]);

  return {
    data,
    mutate,
    isLoading: status === "pending",
    isSuccess: status === "success",
    isError: status === "error",
    error,
    variables: lastParams,
  };
}
